import { AsyncSubject, BehaviorSubject, Observable } from 'rxjs';
import { logger } from '../../services/logging/logging.service';

export abstract class VoiceRecognitionService {

    private AUDIO_PATH = "./assets/audio/dingding.wav";
    private audio!: HTMLAudioElement;
    protected isDeviceSupport$: AsyncSubject<boolean> = new AsyncSubject<boolean>();
    protected isCompleted$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    protected isListening$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    protected message$: BehaviorSubject<string> = new BehaviorSubject<string>('');
    abstract init(): void;
    abstract start(): void;
    abstract stop(): void;

    protected SILENT_TIMEOUT = 2000;
    protected silentTimer: any;

    // Play the Audio file and return a promise that resolves when the audio ends
    // or rejects if there is an error
    // This is because the Speech Recongition API in IOS will return "No speech detected" if the audio is still playing
    protected playAudio(): Promise<boolean> {
        return new Promise<boolean>((resolve, reject) => {
            if (!this.audio) {
                this.audio = new Audio(this.AUDIO_PATH);
                this.audio.load();
            }

            this.audio.addEventListener("ended", () => {
                resolve(true);
            });
            this.audio.addEventListener("error", () => {
                resolve(false);
            });
            this.audio.play();
        });
    }

    protected updateSilentTimer() {
        if (this.silentTimer) {
            clearTimeout(this.silentTimer);
        }

        this.silentTimer = setTimeout(() => {
            logger.debug("Silent Timer was fired");
            this.isListening().then((isListening) => {
                if (isListening) {
                    this.stop();
                }
            });
        }, this.SILENT_TIMEOUT);
    }

    public async isListening(): Promise<boolean> {
        return this.isListening$.value;
    }

    public isCompleted(): Observable<boolean> {
        return this.isCompleted$.asObservable();
    }

    public isDeviceSupport(): Observable<boolean> {
        return this.isDeviceSupport$.asObservable();
    }

    public message(): Observable<string> {
        return this.message$.asObservable();
    }

}
